var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(190, 33, 38)",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.81 20.97L32.64 8.23a.997.997 0 0 0-1.28 0l-6.38 5.35A19.324 19.324 0 0 1 27 21.05a15.918 15.918 0 0 1-11 15.26V47a1.003 1.003 0 0 0 1 1h11V36a1.003 1.003 0 0 1 1-1h6a1.003 1.003 0 0 1 1 1v12h12V21.38a.565.565 0 0 0-.19-.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 21.05a13.45 13.45 0 0 0-1.21-4.78c-2.6-6.29-8.61-14.31-10-16.12a.356.356 0 0 0-.58 0C9.42 2.48 0 15.07 0 21.05A11.732 11.732 0 0 0 11.5 33a11.098 11.098 0 0 0 4.5-.95 11.978 11.978 0 0 0 7-11zM11.5 30A5.586 5.586 0 0 1 6 24.33c0-2.83 4.51-9.15 5.36-10.26a.179.179 0 0 1 .28 0 47.707 47.707 0 0 1 4.41 7.1v.01a8.292 8.292 0 0 1 .95 3.15 5.734 5.734 0 0 1-1 3.25A5.43 5.43 0 0 1 11.5 30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.aceb204c0b21270acc99f98ca50ca533.svg";
export { ForwardRef as ReactComponent };